import { render, staticRenderFns } from "./CreateDocumentYearReview.vue?vue&type=template&id=9ae1a59e&scoped=true&"
import script from "./CreateDocumentYearReview.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentYearReview.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentYearReview.vue?vue&type=style&index=0&id=9ae1a59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae1a59e",
  null
  
)

export default component.exports